import axiosInstance from "../../utility/axios";

// state
import { disableLoading } from "../../store/slices/loading";
import {
  setCompanyLoading,
  setCompany,
  setSearch,
  setCompanies,
  setCompanyDoc,
  setCompanyEmp,
  createCompany as newCompany,
  deleteCompany,
  setStatusUpdate,
  setLoading,
  setLoadingCompanyId,
  createDocument,
  setFileLogs,
  setTotal,
  setMonthTotal,
  setCompanyBranch,
  setCompanyBranchUsers,
  setNewCompanyBranchUser,
  updateDocument,
  deleteDocument,
} from "../../store/slices/company";
import { isAxiosError } from "axios";
import { AppDispatch } from "../../store/store";
import {
  ICompanyDocument,
  ICreateCompany,
  ICreateCompanyBranchUser,
} from "../../store/types/company";
import { toast } from "sonner";

export const getAllCompany = async (dispatch: AppDispatch) => {
  dispatch(setLoading(true));
  try {
    const response = await axiosInstance.get("/v1/get-all-company");
    if (response.data) {
    }
  } catch (err) {
    if (isAxiosError(err)) console.log(err?.response?.data);
  } finally {
    dispatch(setLoading(false));
  }
};

export const createCompany = async (
  data: ICreateCompany,
  dispatch: AppDispatch,
) => {
  dispatch(setLoading(true));
  try {
    const response = await axiosInstance.post("/v1/create-company", data);

    toast.success("Company has been created");
    dispatch(newCompany(response.data));
  } catch (err) {
    if (isAxiosError(err)) console.log(err?.response?.data);
  } finally {
    dispatch(setLoading(false));
  }
};

export const get_companies = async (
  dispatch: AppDispatch,
  page: number = 1,
) => {
  dispatch(setLoading(true));
  try {
    const response = await axiosInstance.get(`/v1/get-companies?page=${page}`);

    dispatch(setCompanies(response.data.data));
  } catch (err: any) {
    if (isAxiosError(err)) {
      console.log(err?.response?.data);
    }
  } finally {
    dispatch(setLoading(false));
  }
};

// /admin/toggle-company-status/6dd0d42a-803c-4745-b1c8-26947994445
export const getCompanyEmp = async (id: string, dispatch: AppDispatch) => {
  dispatch(setLoading(true));
  try {
    const response = await axiosInstance.get(`/company-employees/${id}`);
    if (response.data) {
      dispatch(setCompanyEmp(response.data));
    }
  } catch (err) {
    // const { data } = err.response;
    // openNotification({
    //   type: "error",
    //   title: "Incorrect Credentials",
    //   description: data.message,
    // });
  } finally {
    dispatch(setLoading(false));
  }
};

export const getCompanyDoc = async (id: string, dispatch: AppDispatch) => {
  dispatch(setLoading(true));
  try {
    const response = await axiosInstance.get(`/company-docs/${id}`);

    const { data } = response.data;
    dispatch(setCompanyDoc(data));
  } catch (err: any) {
    if (isAxiosError(err)) console.log("Err:", err?.response?.data);
  } finally {
    dispatch(setLoading(false));
  }
};

export const setRemoveUser = async (data: string, dispatch: AppDispatch) => {
  dispatch(setCompanyLoading());
  try {
    const response = await axiosInstance.get(`/remove-from-company/${data}`);

    if (response.data) {
      toast.success("User has been removed from company");
    }
  } catch (err: any) {
    if (isAxiosError(err)) {
      toast.error(err?.response?.data?.message);
    }
  }
  dispatch(disableLoading());
};

export const searchCompany = async (search: string, dispatch: AppDispatch) => {
  dispatch(setLoading(true));
  try {
    const response = await axiosInstance.get(`/search-company/${search}`);
    if (response.data) {
      dispatch(setSearch(response.data));
    }
  } catch (err) {
    if (isAxiosError(err)) console.log(err?.response?.data);
  } finally {
    dispatch(setLoading(false));
  }
};

// Edited
export const company_status = async (id: string, dispatch: AppDispatch) => {
  dispatch(setLoading(true));
  try {
    const response = await axiosInstance.get(`/v1/toggle-company-status/${id}`);

    const { message, data } = response.data;
    dispatch(setStatusUpdate(data));
    toast.success(message);
  } catch (err) {
    if (isAxiosError(err)) {
      console.log(err?.response?.data);
    }
  } finally {
    dispatch(setLoading(false));
  }
};

// Edited
export const premium_status = async (id: string, dispatch: AppDispatch) => {
  dispatch(setLoading(true));
  try {
    const response = await axiosInstance.get(
      `/v1/toggle-company-premium/${id}`,
    );

    const { message, data } = response.data;
    dispatch(setStatusUpdate(data));
    toast.success(message);
  } catch (err) {
    if (isAxiosError(err)) {
      console.log(err?.response?.data);
    }
  } finally {
    dispatch(setLoading(false));
  }
};

export const get_company = async (id: string, dispatch: AppDispatch) => {
  dispatch(setLoading(true));
  try {
    const response = await axiosInstance.get(`/v1/get-company/${id}`);

    const { data } = response.data;
    dispatch(setCompany(data));
  } catch (err) {
    if (isAxiosError(err)) {
      const { data } = err?.response?.data;
      console.log(data);
    }
  } finally {
    dispatch(setLoading(false));
  }
};

export const delete_company = async (id: string, dispatch: AppDispatch) => {
  dispatch(setLoadingCompanyId(id));
  try {
    const response = await axiosInstance.delete(`/v1/delete-company/${id}`);
    const { message, data } = response.data;
    dispatch(deleteCompany(id));
    toast.success(message || "Company deleted successfully");
    return data;
  } catch (err) {
    if (isAxiosError(err)) {
      const msg = err?.response?.data?.message || "Could not delete company.";
      toast.error(msg);
    }
  } finally {
    dispatch(setLoadingCompanyId(null));
  }
};

export const create_company_docs = async (
  form_data: ICompanyDocument,
  dispatch: AppDispatch,
) => {
  dispatch(setLoading(true));
  try {
    const response = await axiosInstance.post("/v1/create-document", form_data);
    const { data } = response.data;
    toast.success("Doument upload successful");
    dispatch(createDocument(data));
  } catch (err) {
    if (isAxiosError(err)) {
      const { message } = err?.response?.data;
      toast.error(message);
    }
  } finally {
    dispatch(setLoading(false));
  }
};

export const edit_company_docs = async (
  form_data: ICompanyDocument,
  dispatch: AppDispatch,
) => {
  dispatch(setLoading(true));
  try {
    const response = await axiosInstance.patch(
      "/v1/update-document",
      form_data,
    );
    const { data } = response.data;
    toast.success("Document updated successfully");
    dispatch(updateDocument(data));
  } catch (err) {
    if (isAxiosError(err)) {
      const { message } = err?.response?.data;
      toast.error(message);
    }
  } finally {
    dispatch(setLoading(false));
  }
};

export const delete_company_docs = async (
  id: string,
  dispatch: AppDispatch,
) => {
  dispatch(setLoading(true));
  try {
    await axiosInstance.delete(`/v1/delete-document/${id}`);
    toast.success("Document deleted successfully");
    dispatch(deleteDocument(id));
  } catch (err) {
    if (isAxiosError(err)) {
      const { message } = err?.response?.data;
      toast.error(message);
    }
  } finally {
    dispatch(setLoading(false));
  }
};

export const rc_number_exists = async (id: string) => {
  try {
    const response = await axiosInstance.get(`/get-company-by-rc/${id}`);

    const { data } = response.data;
    toast.success("RC Number exists.");
    return data;
  } catch (err) {
    if (isAxiosError(err)) {
      const { data } = err?.response?.data;
      return data;
    }
  }
};

export const show_company = async (id: string, dispatch: AppDispatch) => {
  try {
    const response = await axiosInstance.get(`/get-company/${id}`);

    const { data } = response.data;
    dispatch(setCompany(data));
  } catch (err) {
    if (isAxiosError(err)) {
      const { data } = err?.response?.data;
      return data;
    }
  }
};

export const get_user_logs = async (email: string, dispatch: AppDispatch) => {
  try {
    const response = await axiosInstance.get(
      `/v1/get-user-document-logs/${email}`,
    );

    const { data } = response.data;
    dispatch(setFileLogs(data));
  } catch (err) {
    if (isAxiosError(err)) {
      const { data } = err?.response?.data;
      return data;
    }
  }
};

export const get_total = async (dispatch: AppDispatch) => {
  dispatch(setLoading(true));
  try {
    const response = await axiosInstance.get("/v1/get-total-companies");

    const { data } = response.data;
    dispatch(setTotal(data));
  } catch (err: any) {
    if (isAxiosError(err)) {
      // Do something with error
    }
  } finally {
    dispatch(setLoading(false));
  }
};

export const monthly_total = async (dispatch: AppDispatch) => {
  dispatch(setLoading(true));
  try {
    const response = await axiosInstance.get("/v1/get-total-companies");

    const { data } = response.data;
    dispatch(setMonthTotal(data));
  } catch (err: any) {
    if (isAxiosError(err)) {
      // Do something with error
    }
  } finally {
    dispatch(setLoading(false));
  }
};

export const getCompanyBranch = async (id: string, dispatch: AppDispatch) => {
  dispatch(setLoading(true));
  try {
    const response = await axiosInstance.get(`/v1/get-company-branches/${id}`);
    const { data } = response.data;
    dispatch(setCompanyBranch(data));
    return data;
  } catch (err) {
    if (isAxiosError(err)) {
      console.warn("cannot load branches", err.response?.data);
    }
  } finally {
    dispatch(setLoading(false));
  }
};

export const getCompanyBranchUsers = async (
  id: string,
  dispatch: AppDispatch,
) => {
  dispatch(setLoading(true));
  try {
    const response = await axiosInstance.get(
      `/v1/get-company-users-branch/${id}`,
    );
    const { data } = response.data;
    dispatch(setCompanyBranchUsers(data));
    return data;
  } catch (err) {
    if (isAxiosError(err)) {
      console.warn("cannot load branches", err.response?.data);
    }
  } finally {
    dispatch(setLoading(false));
  }
};

export const createCompanyBranchUser = async (
  id: string,
  data: ICreateCompanyBranchUser,
  dispatch: AppDispatch,
) => {
  try {
    const response = await axiosInstance.post("v1/create-company-user", {
      ...data,
      branch_id: id,
    });

    const { data: resData } = response.data;
    toast.success("Branch user has been created");
    dispatch(setNewCompanyBranchUser(resData));
  } catch (err) {
    if (isAxiosError(err)) {
      console.warn("cannot create branch user", err.response?.data);
    }
  }
};
